import _ from "lodash";
import LZString from "lz-string";
import * as z from "../../../framework";
import UserDashboardPopUp from "../../shared/userDashboards/userDashboardsPopUp";
import * as ui from "../ui";
import * as widgets from "./widgets";

var containerName;
var screenCode;

export var Portal = function (args: any) {
    args = args || {};
    containerName = args.containerName;
    screenCode = args.screenCode;
    var wrapper = this.wrapper = args.containerId
        ? $(`#${args.containerId}`)
        : args.container;

    var portalContainer = new ui.PortalContainer({
        classes: "container portal-container",
        id: "PortalContainer"
    });

    portalContainer.render(wrapper);
    this.container = $("#PortalContainer");
    this.widgets = [];
    this.init();

    this.container.animate({
    }, {
        queue: true,
        duration: 100,
        complete: function () {
            z.layout.resizeToPortalContainer();
        }
    });
};

Portal.prototype = {

    init: function () {
        let me = this,
            screen = _.find(z.codes.Screen, function (data) {
                if (data.CodeNumber.toUpperCase() == screenCode.toUpperCase()) {
                    return data.Id;
                }
            });

        if (!screen) {
            return;
        }

        let currentScreenId = screen.Id,
            lookerEnabled = z.util.getBooleanOption("LookerEnabled", false);

        if (lookerEnabled) {
            let screensWithDashboards = (localStorage && localStorage.ScreensWithLookerDashboards && JSON.parse(localStorage.ScreensWithLookerDashboards)) || [],
                thisScreenHasLookerDashboard = _.indexOf(screensWithDashboards, currentScreenId);

            if (thisScreenHasLookerDashboard > -1) {
                let detectedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                me.initLookerDashboard(currentScreenId, detectedTimezone);
            } else {
                me.initServiceProDashboard(currentScreenId);
            }
        } else {
            me.initServiceProDashboard(currentScreenId);
        }
    },
    initServiceProDashboard: function (screenId: number) {
        let me = this;

        var widgetInstances = {};
        if (localStorage.WidgetInstances) {
            widgetInstances = $.parseJSON(LZString.decompressFromUTF16(localStorage.WidgetInstances));
        }

        if (widgetInstances[screenId]) {
            me.widgets = widgetInstances[screenId];
            initWidgetInstances();
        } else {
            let widgetInstanceExpand = [
                "Widget",
                "Widget/WidgetType"
            ].join(",");

            z.ajax({
                type: "GET",
                url: `WidgetInstance/?$expand=${widgetInstanceExpand}&$filter=ScreenId eq ${screenId}`
            }).done(function (response) {
                me.widgets = response.d.results;

                widgetInstances[screenId] = me.widgets;
                localStorage.setItem("WidgetInstances", LZString.compressToUTF16(JSON.stringify(widgetInstances)));

                initWidgetInstances();
            });
        }

        function initWidgetInstances() {
            var widgetFound = false,
                widgetIds = [];

            $.each(me.widgets, function (index, c) {
                widgetIds.push(`#PortalWidget${(index + 1)}`);
            });

            function placeholder(element) {
                return element.clone().addClass("z-portal-placeholder");
            }

            function hint(element) {
                return element.clone().addClass("z-portal-hint")
                    .height(element.height())
                    .width(element.width());
            }

            me.widgets.sort(function (a, b) {
                return a.SortOrder > b.SortOrder;
            });

            $.each(me.widgets, function (index, widget) {

                var widgetView = new ui.Container({
                    classes: `portal-widget col-xs-${widget.Width}`,
                    label: "Check",
                    id: widgetIds[index].substring(1)
                });
                widgetView.render(me.container);

                var deferred = {};

                widget.widgetElement = $(widgetIds[index]);

                var widgetType = widget.Widget.WidgetType.Value,
                    widgetIndex = (widget.Widget.WidgetName + widgetIds[index].substring(1));
                me.widgets[widgetIndex] = new widgets[widgetType](widget);
                var widgetPrototype = me.widgets[widgetIndex];
                if (widgetPrototype.initAsync) {
                    deferred = widgetPrototype.initAsync();
                }
                widgetFound = true;

                $.when(deferred).then(function () {
                    var kendoSortable = $(widgetIds[index]).kendoSortable({
                        handler: ".z-widget-header",
                        cursor: "move",
                        placeholder: placeholder,
                        hint: hint,
                        ignore: "input,textarea"
                    });

                    kendoSortable.bind("change", function () {
                        z.layout.resizeToPortalContainer();
                    });
                });
            });

            if (widgetFound) {
                $(".full-workspace").css("background-color", $("body").css("background-color"));
                $(".left-column-menu").addClass("hidden");
                $(".sp-logo-gray-tagline").hide();
            } else {
                me.container.hide();
            }

            me.wrapper.show().css("opacity", 1);
            $("#PortalContainer").css("z-index", "2");
        }
    },
    initLookerDashboard: function (screenId: number, detectedTimezone: string) {
        z.ajax({
            url: `Dashboard/GenerateUrls/${screenId}?userTimezone=${detectedTimezone}`,
            type: "POST",
            errorHandled: true
        }).done(function (response) {
            var urlTitlePairs = response.d.results,
                portalContainer = $("#PortalContainer"),
                dropdownListDataSource = [],
                dashboardPanels = [];

            _.each(urlTitlePairs, function (urlTitlePair, index) {
                let num = index + 1,
                    panelId = `DashboardPanel${num}`;

                dropdownListDataSource.push({
                    Title: urlTitlePair.Title,
                    Value: panelId
                });

                dashboardPanels.push(new ui.HTML({
                    HTML: `<div class="portal-widget col-xs-12 looker-dashboard-container" id="${panelId}">
                               <iframe src="${urlTitlePair.Url}" width="100%"></iframe>
                           </div>`
                }));
            });

            const manageDashboardsButtonContainer = (): ui.Container[] => {
                const lookerDashboardEditRight = "LKEXGX";
                if (z.userHasRight(lookerDashboardEditRight)) {
                    return [
                        new ui.Container({
                            classes: "right",
                            components: [
                                new ui.Button({
                                    id: "EditDashboardConfiguration",
                                    label: "ManageDashboardsButton",
                                    classes: "w-150"
                                })
                            ]
                        })
                    ];
                }

                return [];
            };

            new ui.Container({
                components: [
                    new ui.Container({
                        bsc: "col-xs-12 pad-t-10",
                        components: [
                            new ui.Container({
                                components: [
                                    new ui.Container({
                                        classes: "left-col",
                                        components: [
                                            new ui.DropDownList({
                                                id: "DashboardSelector",
                                                bsc: "col-xs-10",
                                                labelBsc: "col-xs-2",
                                                label: z.ll("Dashboard"),
                                                bindValue: "Title",
                                                classes: "js-options-bind",
                                                containerClasses: "mar-b-0",
                                                dataTextField: "Title",
                                                dataValueField: "Value",
                                                dataSource: dropdownListDataSource,
                                                required: false,
                                                width: 450,
                                                containerWidth: 450,
                                                change: function (e) {
                                                    let selectedIndex = (e.sender as any).selectedIndex;
                                                    _.forEach(dropdownListDataSource, function (dataItem, index) {
                                                        let panelId = dataItem.Value;
                                                        if (index == selectedIndex) {
                                                            $(`#${panelId}`).show();
                                                        } else {
                                                            $(`#${panelId}`).hide();
                                                        }
                                                    });
                                                }
                                            }),
                                            new ui.Label({
                                                id: "DashboardHeading",
                                                bindValue: "LookerDashboardContainerHeading",
                                                classes: "about-label-large"
                                            })
                                        ]
                                    }),
                                    ...manageDashboardsButtonContainer()
                                ]
                            })
                        ]
                    }),
                    ...dashboardPanels
                ]
            }).render(portalContainer);
            z.bindLocalizedLanguage({ container: portalContainer });

            var lookerDashboardContainerHeadingIsVisible = z.util.getBooleanOption("LookerDashboardContainerHeadingIsVisible", true);
            if (lookerDashboardContainerHeadingIsVisible) {
                $("#DashboardHeading").show();
            } else {
                $("#DashboardHeading").hide();
            }

            _.forEach(dropdownListDataSource, function (dataItem, index) {
                let panelId = dataItem.Value;
                if (index == 0) {
                    $(`#${panelId}`).show();
                } else {
                    $(`#${panelId}`).hide();
                }
            });

            $("#EditDashboardConfiguration").tie("click", function () {
                let popup = new UserDashboardPopUp();
                popup.popUp({
                    screenId: screenId
                });
            });

            const applyLookerStylesDelayInMilliseconds = 3000;
            const applyStyleFunction = function () {
                if ($("#DashboardSelector").visible()) {
                    portalContainer.addClass("looker-dashboard-wrapper");
                    $("body").addClass("looker");
                }
            };

            setTimeout(applyStyleFunction, applyLookerStylesDelayInMilliseconds);
        }).fail(function (response) {
            let errorCode = response.responseJSON.Errors.General[0].ErrorCode;
            console.error(`Error occurred generating urls for screenId=${screenId} with errorCode=${errorCode}.`);
            $("body").removeClass("looker");
        });
    }
};

export function retrieveRegionAndDivisionFiltering(options) {
    var searchTypeInfo = z.searchTypes["" + options.mainEntity + ""];

    if (!searchTypeInfo) {
        searchTypeInfo = {
            divisionsNavigationTypes: "",
            regionsNavigationTypes: ""
        };
    }

    var divisions = options.divisions === undefined
        ? searchTypeInfo.divisions
        : options.divisions;
    var regions = options.regions === undefined
        ? searchTypeInfo.regions
        : options.regions;

    if (divisions) {
        var divisionsNavType = (options.divisionsNavigationTypes || searchTypeInfo.divisionsNavigationTypes) || "",
            divFilter = z.divisionRegion.createDivisionsFilterStrings(-2, divisionsNavType);
        if (divFilter) {
            options.filter += ` and ${divFilter}`;
        }
    }

    let defaultRegionId = z.user.companyData.EmployeeDefaultRegionId,
        defaultRegion = _.find(z.codes.Region, { Id: defaultRegionId } as {}),
        defaultRegionIsGlobalRegion = defaultRegion && defaultRegion.RegionNumber && defaultRegion.RegionNumber.toUpperCase() == "GLOBAL";

    if (regions && !defaultRegionIsGlobalRegion) {
        var regionNavType = (options.regionsNavigationTypes || searchTypeInfo.regionsNavigationTypes) || "",
            regionFilter = `${regionNavType}Region/EmployeeRegion/UserId eq ${z.user.loginData.UserId}`;
        options.filter += ` and ${regionFilter}`;
    }
}
